import React from 'react'
import { Route } from 'react-router-dom'
import NotFoundPage from '../../pages/not-found/not-found.page'
import { setAuth } from '../../redux/auth/auth.actions'
import {
  setActiveSection,
  setInitialCompletedSections,
  setUploadFilesOnAuth,
} from '../../redux/user-attachment-ui/user-attachment-ui.actions'
import { setAuthRequestEndError, setAuthRequestEndSuccess } from '../../redux/ui/ui.actions'
import { extractAuthInfoForAttachment } from '../../utils/redux'
import { getActiveSectionName } from '../../utils/utils'
import useAuthentication from '../../hooks/useAuthentication'

const AttachmentAuthentication = ({ children, ...restProps }) => {
  const { isAuthInProgress, isAuthSuccess, secret, variationPersist, dispatch } = useAuthentication(async (data) => {
    dispatch(setAuth(extractAuthInfoForAttachment(data)))
    dispatch(setUploadFilesOnAuth(data.attachmentSections))
    dispatch(setInitialCompletedSections(data.attachmentSections))
    dispatch(setActiveSection(getActiveSectionName(data.attachmentSections)))
    await variationPersist(data, secret, (success) => {
      if (success) {
        dispatch(setAuthRequestEndSuccess())
        // Optimizely dropped in favor of Convert (see src/utils/track.js). Convert has no
        // equivalent for pushing arbitrary user attributes, so the `has_rsv` push was removed
        // rather than ported.
      } else {
        dispatch(setAuthRequestEndError())
      }
    })
  })

  return <Route {...restProps} render={() => (isAuthInProgress || isAuthSuccess ? children : <NotFoundPage />)} />
}

AttachmentAuthentication.displayName = 'AttachmentAuthentication'

export default AttachmentAuthentication
